import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { horarioAsignarLst } from 'src/app/models/horarioAsignarLst';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { HorarioService } from 'src/app/services/horario.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-edit-horarios-deportista',
  templateUrl: './edit-horarios-deportista.component.html',
  styleUrls: ['./edit-horarios-deportista.component.scss'],
})
export class EditHorariosDeportistaComponent implements OnInit {
  public nombreUsuario: string = '';
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  pageIndex: number = 0;
  pageSize: number = 200;
  length: number;
  searchString: string = '';
  public dataInput: any;
  public lstDisciplinas: any;
  public disciplinaSelect: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    public horarioSvc: HorarioService,
    public usrSvc: UserService,
    public disciplinaSvc: DisciplinaService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditHorariosDeportistaComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);

    let ELEMENT_DATA: horarioAsignarLst[] = [];
    this.displayedColumns = ['nombre', 'disciplina', 'dias','horario','estado'];

    this.dataSource = new MatTableDataSource<horarioAsignarLst>(ELEMENT_DATA);

  }

  ngOnInit(): void {
    // this.inicarFormulario();

    this.nombreUsuario = this.dataInput.nombre;
    this.getListadoHorarios(0, 10);

    this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
      console.log(disLst);
      this.lstDisciplinas = disLst;
    });

  }

  getListadoHorarios(page: number, numReg: number) {
    this.horarioSvc
      .getHorariosUsuarioYDisponibles({
        page,
        numReg,
        searchString: this.searchString,
        usuarioId: this.dataInput.id,
        filtroEmpresa:this.dataInput.filtroEmpresa,
        disciplinaId:this.disciplinaSelect
      })
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<horarioAsignarLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;

      });
  }

  cambioDiscipinaBuscar() {
    this.pageIndex=0;
    this.pageSize=10;
    this.getListadoHorarios(this.pageIndex, this.pageSize);
  }
  

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getListadoHorarios(event.pageIndex, event.pageSize);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onToggle(ob: MatSlideToggleChange, elemento: any) {
    console.log(ob.checked);
    console.log(elemento);

     this.horarioSvc
      .editarUsuarioHorario(this.dataInput.id,elemento.id,  ob.checked)
      .subscribe((result) => {
        if (result) {
          elemento.asignado = ob.checked;
        } else {
          console.log('error al cambiar de estado');
        }
      }); 
  }
}
